import React from 'react'
import PropTypes from 'prop-types'
import Text from './Text'

class Error extends React.Component {
  render() {
    const {text} = this.props

    if (!text) {
      return null
    }

    return <Text text={text} modifier="error" />
  }
}

Error.propTypes = {
  text: PropTypes.string.isRequired,
}

export default Error
